document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('.dropdown-localization localization-form-component select[name="language_code"]');
  if (!select) return;

  const wrapper = select.closest('.language-selector');
  if (!wrapper) return;

  // Nascondi select nativo
  select.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:0;height:0;';

  // Pulsante
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'lang-custom-btn';
  btn.innerHTML = select.options[select.selectedIndex].text + '<span class="lang-caret"></span>';
  wrapper.appendChild(btn);

  // Lista
  const list = document.createElement('ul');
  list.className = 'lang-custom-list';
  Array.from(select.options).forEach(opt => {
    const li = document.createElement('li');
    li.textContent = opt.text;
    li.dataset.value = opt.value;
    if (opt.selected) li.classList.add('active');
    li.addEventListener('click', () => {
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    list.appendChild(li);
  });
  wrapper.appendChild(list);

  btn.addEventListener('click', e => {
    e.stopPropagation();
    list.classList.toggle('open');
    btn.classList.toggle('open');
  });

  document.addEventListener('click', () => {
    list.classList.remove('open');
    btn.classList.remove('open');
  });
});